import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataToSendDichiarazione } from '../../dischiarazione.models';

@Component({
    selector: 'app-dettagli-credito-anno-prec-compensato-mod-F24',
    templateUrl: './dettagli-credito-anno-prec-compensato-mod-F24.component.html',
    styleUrls: ['./dettagli-credito-anno-prec-compensato-mod-F24.component.scss'],
})
export class DettagliCreditoAnnoPrecCompensatoModF24Component implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<DettagliCreditoAnnoPrecCompensatoModF24Component>,
        @Inject(MAT_DIALOG_DATA)
        public dettagliCreditoCompensatoF24: { cellId: string; dataToSendDichiarazione: DataToSendDichiarazione }
    ) {}

    get cellIsProvvisoria() {
        return this.dettagliCreditoCompensatoF24.cellId.endsWith('provvisoria');
    }

    ngOnInit() {}
}
